import {
  MedicalFacilityContactProps,
  MedicalFacilityContactViewModelBase,
} from 'src/store/generated/medical-facility-contact-record.generated';
import { MedicalFacilityViewModel } from './medical-facility-view-model';

export class MedicalFacilityContactViewModel extends MedicalFacilityContactViewModelBase {
  constructor(
    props: MedicalFacilityContactProps,
    public readonly medicalFacility: MedicalFacilityViewModel,
  ) {
    super(props);
  }
}
